import React from 'react';
import ArrowAppLnk from './../../../icons/arrow-app-link.svg';
import { localize } from '../helpers';

export const ApiLink = ({ href, onClick, translations }) => {
    return (
        <div className="api__link">
            <a
                href={href}
                onClick={(e) => {
                    e.preventDefault();
                    onClick();
                }}
            >
                {localize('api-link', translations)}
            </a>
            <ArrowAppLnk />
        </div>
    );
};
